import React from "react";

function MarketInsight() {
    return (
        <div className="container p-5">
            <div
                className="pricing-style-one-item-cos bg-dark text-light"
                style={{
                    backgroundImage:
                        "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
                }}
            >
                <div className="text-center">
                    <h3>Web3 Gaming Market Insight

                    </h3>
                    <div className="bottom">
                        <div className="pricing">
                            <p>
                                The Web3 gaming market is experiencing explosive growth, with market valuation projected to reach approximately $65.7 billion by 2027, growing at a CAGR of 21.9% from the past year. This surge is driven by the increasing popularity of decentralized gaming ecosystems, NFTs, and play-to-earn models, where players have true ownership of in-game assets.
                            </p>
                        </div>
                        <a className="btn btn-style-one mt-30" href="#">
                            Get Started
                        </a>
                    </div>
                </div>
                {/* <div className="right-info"></div> */}
            </div>
        </div>
    );
}

export default MarketInsight;